import React, { useState } from 'react';
import { useT } from '../i18n';
interface SlideOneProps {
  onNext: (selectedOption: number) => void;
  onCTA: () => void;
}
export function SlideOne({
  onNext,
  onCTA
}: SlideOneProps) {
  const {
    t
  } = useT();
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const handleOptionClick = (index: number) => {
    if (selectedOption !== null) return;
    setSelectedOption(index);
    setTimeout(() => {
      onNext(index);
    }, 600);
  };
  const OPTIONS = [t('poll.option0'), t('poll.option1'), t('poll.option2')];
  return <div className="flex flex-col h-full w-full justify-center animate-fade-in-up" data-id="element-231">
      <div className="mb-8 text-center" data-id="element-232">
        <h1 className="text-3xl md:text-4xl font-extrabold text-white mb-4 leading-tight" data-id="element-233">
          {t('poll.headline')}
        </h1>
        <p className="text-solventum-secondary text-lg font-body" data-id="element-234">
          {t('poll.subtitle')}
        </p>
      </div>

      <div className="flex flex-col space-y-3 mb-10 w-full" role="radiogroup" aria-label="Poll options" data-id="element-235">
        {OPTIONS.map((option, index) => {
        const isSelected = selectedOption === index;
        const isOtherSelected = selectedOption !== null && selectedOption !== index;
        return <button key={index} onClick={() => handleOptionClick(index)} disabled={selectedOption !== null} role="radio" aria-checked={isSelected} className={`
                relative w-full py-4 px-6 rounded-xl text-left font-body text-lg transition-all duration-300 border-2
                ${isSelected ? 'bg-solventum-primary border-solventum-primary text-solventum-bg font-bold scale-[1.02]' : 'bg-transparent border-solventum-secondary text-white hover:border-solventum-primary hover:bg-white/5'}
                ${isOtherSelected ? 'opacity-50 scale-[0.98]' : 'opacity-100'}
              `} data-id="element-236">
              {option}
            </button>;
      })}
      </div>

      <button onClick={onCTA} className="w-full bg-solventum-primary hover:bg-[#04c444] text-solventum-bg font-headline font-extrabold py-4 px-6 rounded-xl transition-colors duration-200 text-lg shadow-[0_0_15px_rgba(5,221,77,0.2)]" data-id="element-237">
        {t('poll.cta')}
      </button>
    </div>;
}